module.exports = __webpack_public_path__ + "static/furnisima-pbcst-custom-e2f4ce20354937b5d1b8ba8c582b51fa.png";